import type { ImpactCenterArtifactoryStorageInfoResponse } from "@shared/services/impact-center/getImpactCenterArtifactoryStorageInfo.ts";

const TOUR_SERVER_NAME = "demo";

export default async (): Promise<ImpactCenterArtifactoryStorageInfoResponse> => ({
  results: [
    {
      technicalServerName: TOUR_SERVER_NAME,
      storage: {
        binariesSize: "10 GB",
        artifactsSize: "25 GB",
        optimization: "60%",
      },
    },
  ],
});
